import { LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "MailPrefetch", webpackPrefetch: true */ './lazyIndex');
});
// Delay actions
export var lazyPrefetchRowInCache = new LazyAction(lazyModule, function (m) { return m.prefetchRowInCache; });
export var lazyPrefetchSingleRow = new LazyAction(lazyModule, function (m) { return m.prefetchSingleRow; });
export var lazyPrefetchFirstN = new LazyAction(lazyModule, function (m) { return m.prefetchFirstN; });
export var lazyPrefetchAdjacentItemsOnDelay = new LazyAction(lazyModule, function (m) { return m.prefetchAdjacentItemsOnDelay; });
//# sourceMappingURL=index.js.map